<div class="p-6 bg-white rounded-xl shadow-lg">
  <h2 class="text-2xl font-bold text-gray-800 mb-6">Dashboard Overview</h2>

  <div *ngIf="loading" class="text-gray-500">Loading dashboard data...</div>

  <div *ngIf="!loading" class="grid grid-cols-1 md:grid-cols-4 gap-6">
    <!-- Orders -->
    <div class="p-6 bg-blue-50 rounded-lg shadow">
      <h3 class="text-sm text-gray-500">Total Orders</h3>
      <p class="text-3xl font-bold text-blue-600">{{ stats.totalOrders }}</p>
    </div>

    <!-- Revenue -->
    <div class="p-6 bg-green-50 rounded-lg shadow">
      <h3 class="text-sm text-gray-500">Total Revenue</h3>
      <p class="text-3xl font-bold text-green-600">৳{{ stats.totalRevenue }}</p>
    </div>

    <!-- Products -->
    <div class="p-6 bg-purple-50 rounded-lg shadow">
      <h3 class="text-sm text-gray-500">Total Products</h3>
      <p class="text-3xl font-bold text-purple-600">{{ stats.totalProducts }}</p>
    </div>

    <!-- Customers -->
    <div class="p-6 bg-yellow-50 rounded-lg shadow">
      <h3 class="text-sm text-gray-500">Total Customers</h3>
      <p class="text-3xl font-bold text-yellow-600">{{ stats.totalCustomers }}</p>
    </div>
  </div>
</div>

